import { createApp } from "vue";
import App from "./App.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faXmark,
  faAngleDown,
  faAngleUp,
  faBars,
  faArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import { createI18n } from "vue-i18n";
import { fetchData } from "./services/api";

import ptBR from "./locales/ptBR.json";
import enUS from "./locales/enUS.json";
import esES from "./locales/esES.json";
import zhCN from "./locales/zhCN.json";
import deDE from "./locales/deDE.json";

// Configurar vue-i18n
const i18n = createI18n({
  legacy: false,
  locale: "PT-BR",
  fallbackLocale: "EN-US",
  messages: {
    "PT-BR": ptBR,
    "EN-US": enUS,
    "ES-ES": esES,
    "ZH-CN": zhCN,
    "DE-DE": deDE,
  },
});

library.add(faXmark, faAngleDown, faAngleUp, faBars, faArrowUp);

const app = createApp(App);
app.use(i18n);
app.component("font-awesome-icon", FontAwesomeIcon);
await fetchData()
  .then((data) => {
    console.log("Dados carregados:", data);

    app.config.globalProperties.whitelabel = data;

    const favicon = document.getElementById("favicon");
    favicon.href = data.icon;

    if (data.color) {
      document.documentElement.style.setProperty('--color-default', data.color);
    }

    console.log("Dados carregados2:", app.config.globalProperties.whitelabel);
  })
  .catch((error) => {
    console.error("Erro ao carregar os dados da API:", error);
  });

app.mount("#app");
